import type { JSX } from 'react';

import { TableComponent } from 'components/TableComponent';

import { ColumnDefinition } from './types';

type SearchableTableContentProps = {
  filteredData: any[];
  rowComponent: (item: any) => JSX.Element;
  columns: ColumnDefinition[];
};

// Table component used in SearchableTable
export const SearchableTableContent = ({
  filteredData, rowComponent, columns,
}: SearchableTableContentProps) => {
  return (
    <TableComponent.TableContainer>
      <TableComponent.Table>
        <TableComponent.TableHeader>
          <TableComponent.TableRow>
            {columns.map((col) => (
              <TableComponent.TableHeaderCell
                key={col.name}
                style={col.style}
                className={col.className}
              >
                {col.name}
                {col.headerElement}
              </TableComponent.TableHeaderCell>
            ))}
          </TableComponent.TableRow>
        </TableComponent.TableHeader>
        <TableComponent.TableBody>
          {filteredData.map((item) => rowComponent(item))}
        </TableComponent.TableBody>
      </TableComponent.Table>
      <TableComponent.TableFooterDiv />
    </TableComponent.TableContainer>
  );
};
